module.exports = __webpack_public_path__ + "media/images/ui-icons_ffffff_256x240-421e54f0fa64fa95935cb22b023ad9c9.png";